import { lazy } from "react";
import { clearStudioView, setStudioView } from "../workspace/studio-views";
import type { FeelingArcModel, FeelingChange } from "./FeelingArc";
const FeelingArc = lazy(() => import("./FeelingArc").then((module) => ({ default: module.FeelingArc })));

export interface FeelingArcMount {
  model: FeelingArcModel;
  busy: boolean;
  onChange: (sectionId: string, change: FeelingChange) => Promise<void>;
}

/** The feeling line on the storyboard step; a production without song sections clears the slot. */
export function mountFeelingArc(projectId: string, props: FeelingArcMount | null) {
  if (!props) return clearStudioView("feeling-arc");
  setStudioView("feeling-arc", `feeling-arc:${projectId}`, <FeelingArc {...props} />);
}
